import React from "react";

export const QuestionForm = ({ questions }) => {
  console.log("questions ", questions.length);
  const labelStyles = {
    color: "rgba(0, 0, 0, 0.88)",
    fontWeight: "400",
    marginBottom: "5px",
    fontSize: "13px",
    display: "block",
  };
  const commonStyles = {
    width: "100%",
    padding: "10px",
    marginTop: "8px",
    borderRadius: "8px",
    fontSize: "13px",
    fontWeight: "300",
    backgroundColor: "#0087A31A",
    boxSizing: "border-box",
    outline: "none",
    ":focus": {
      border: "none",
      outline: "none",
    },
  };

  const renderFieldByType = (question) => {
    switch (question.type) {
      case "text":
      case "number":
      case "password":
      case "email":
      case "tel":
      case "url":
      case "search":
      case "date":
      case "time":
      case "week":
      case "month":
      case "datetime-local":
      case "color":
      case "range":
        return (
          <input
            type={question.type}
            // placeholder={`e.g.${question.placeholder}` || ""}
            placeholder="Please Enter"
            style={commonStyles}
          />
        );
      case "checkbox":
      case "radio":
        return (
          <div>
            <label>
              <input type={question.type} />
              {question.label || question.question}
            </label>
          </div>
        );
      case "multi-select":
        return (
          <div>
            {question.options?.map((option) => (
              <label
                key={option._id}
                style={{ display: "block", marginBottom: "5px" }}
              >
                <input type="checkbox" value={option.value} /> {option.key}
              </label>
            ))}
          </div>
        );

      case "select":
        return (
          <select style={commonStyles}>
            <option value="">-- Select an option --</option>
            {question.options?.map((option) => (
              <option key={option._id} value={option.value}>
                {option.key}
              </option>
            ))}
          </select>
        );
      case "file":
        return <input type="file" />;
      case "title":
        return <h1></h1>;
      default:
        return (
          <p style={{ color: "red" }}>
            Unsupported field type: <strong>{question.type}</strong>
          </p>
        );
    }
  };
  return (
    <form>
      {questions.map((question, index) => (
        <div className="px-20" key={index} style={{ marginBottom: "20px" }}>
          {/* Render label */}
          {question.label && (
            <label style={labelStyles}>{question.label}</label>
          )}
          {question.question && !question.label && (
            <label style={labelStyles}>{question.question}</label>
          )}

          {/* Render field dynamically */}
          <div className=" pb-5">{renderFieldByType(question)}</div>
          <hr className="border-t-[1px] border-gray-200 shadow-[0_0_16px_0_#3BA2B91F]" />
        </div>
      ))}
    </form>
  );
};
